export default "__VITE_ASSET__2e77e414__"